import LoginForm from "../components/LoginForm/LoginForm";

function LoginPage() {
  return <LoginForm />;
}

export default LoginPage;
